import React, { useEffect, useRef, useState } from "react";

export default function StudioPageName({ page, number, location, onRename }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(page.name);
  const inputRef = useRef(null);
  const finished = useRef(false);
  useEffect(() => {
    if (editing) {
      inputRef.current?.focus({ preventScroll: true });
      inputRef.current?.select();
    }
  }, [editing]);
  const finish = (cancel = false) => {
    if (finished.current) return;
    finished.current = true;
    const name = draft.trim();
    if (!cancel && name && name !== page.name) onRename(name);
    setEditing(false);
  };
  return (
    <span className="ms-page-name" onPointerDown={(e) => e.stopPropagation()}>
      {editing ? (
        <input
          ref={inputRef}
          aria-label={`Page ${number} name in ${location}`}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onBlur={() => finish()}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.nativeEvent.isComposing) return;
            if (e.key === "Enter" || e.key === "Escape") {
              e.preventDefault();
              finish(e.key === "Escape");
            }
          }}
        />
      ) : (
        <button
          type="button"
          aria-label={`Rename page ${number} in ${location}`}
          title={`Rename ${page.name}`}
          onClick={() => {
            finished.current = false;
            setDraft(page.name);
            setEditing(true);
          }}
        >
          {page.name}
        </button>
      )}
    </span>
  );
}
